import { netsparkAxios } from 'core/services/HTTPService';
import { getBookingReportDataUrl } from 'pages/Dashboard/api/apiUrls';
import { IRequestPaging } from 'core/services/HTTPService.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';

const getBookingReportData = (signal: AbortSignal, params: object) => netsparkAxios
  .get<IRequestPaging<IBookingDataItem[]>>(getBookingReportDataUrl, { signal, params });

export default getBookingReportData;
